/* eslint-disable react/jsx-no-target-blank, @typescript-eslint/no-non-null-assertion */
import { ErrorLogComponent } from '@cian/error-log-component';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferSchema, IUserSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { MainMortgageBannerContainer, StretchBannerContainer } from '../../containers/Adfox';
import { ComparisonControlContainer } from '../../containers/ComparisonControlContainer';
import { FavoriteButtonContainer } from '../../containers/FavoriteButtonContainer';
import { NewbuildingBuilderStretchBannerContainer } from '../../containers/NewbuildingBuilderStretchBannerContainer';
import { IApplicationContext } from '../../types/applicationContext';
import { ICompanyWithFeatures } from '../../types/newbuildingCompany';
import { getDealType, isSale } from '../../utils/deal_type';
import { getOfferType, isNewbuilding } from '../../utils/offer_type';
import { isSuburbanOfferFromBuilder } from '../../utils/suburban';
import { CommentsButtonContainer } from '../comments/button/container';
import { CommentContainer } from '../comments/comment/container';
import { ExportButtonContainer } from '../export_button/container';
import { GeoContainer } from '../geo/container';
import { HideButtonContainer } from '../hide_button/container';
import { OfferTitleContainer } from '../offer_title/container';
import { ParentContainer } from '../parent/container';
import { SharingContainer } from '../sharing/container';
import { ComplaintButtonContainer } from './complaint_button/container';
import * as styles from './index.css';
import { PrintButtonContainer } from './print_button/container';

export interface IMainProps {
  offer: IOfferSchema;
  user: IUserSchema | null;
  isOpenCommentBlock: boolean;
  isCountrysideCardIntegrated: boolean;
  isNewbuildingBannerEnabled: boolean;
  builderInfo: ICompanyWithFeatures | null;
}

export class Main extends React.PureComponent<IMainProps, {}> {
  public context: IApplicationContext;

  public static contextTypes = {
    config: PropTypes.object,
    logger: PropTypes.object,
    makeRequest: PropTypes.func,
    telemetry: PropTypes.object,
  };

  public render() {
    const { offer, isCountrysideCardIntegrated, isNewbuildingBannerEnabled, builderInfo } = this.props;
    const dealType = getDealType(offer);
    const offerType = getOfferType(offer);

    const isNewbuildingBannerDisabled = isSale(dealType) && isNewbuilding(offerType) && !isNewbuildingBannerEnabled;
    const isBannerVisible = !isSuburbanOfferFromBuilder(offer) && !isNewbuildingBannerDisabled;

    return (
      <section className={styles['main']}>
        <div className={styles['header']}>
          <div className={styles['header-information']}>
            <OfferTitleContainer />
            {!isCountrysideCardIntegrated && <ParentContainer />}
            <GeoContainer />
            {offer.status === 'published' && this.renderToolbar()}
          </div>
          {isBannerVisible && <MainMortgageBannerContainer />}
        </div>
        {this.props.isOpenCommentBlock && (
          <ErrorLogComponent logger={this.context.logger}>
            <CommentContainer />
          </ErrorLogComponent>
        )}
        {builderInfo ? (
          <NewbuildingBuilderStretchBannerContainer builderInfo={builderInfo} />
        ) : (
          <StretchBannerContainer />
        )}
      </section>
    );
  }

  private renderToolbar() {
    return (
      <div {...mergeStyles(styles['tools-container'], this.props.isOpenCommentBlock && styles['width_comment'])}>
        <div className={styles['tool']}>
          <FavoriteButtonContainer />
        </div>
        <div className={styles['tool']}>
          <ComparisonControlContainer />
        </div>
        <div className={styles['tool']}>
          <SharingContainer />
        </div>
        <div className={styles['tool']}>
          <CommentsButtonContainer />
        </div>
        <div className={styles['tool']}>
          <ExportButtonContainer />
        </div>
        <PrintButtonContainer className={styles['tool']} />
        <HideButtonContainer className={styles['tool']} />
        <ComplaintButtonContainer className={styles['tool']} />
      </div>
    );
  }
}
